import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Delete } from "@mui/icons-material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomButton from "../CustomComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../CustomComponents/CustomDateField";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import "./jv.css";
import { BranchAction } from "../Store/Branch";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";

const JournalVoucher = () => {
  const dispatch = useDispatch();
  const [branchNames, setBranchNames] = useState([]);
  const [branchNamesList, setBranchNamesList] = useState([]);
  const [voucherNumber, setVoucherNumber] = useState("");
  const [savedVoucherNumber, setSavedVoucherNumber] = useState("");

  const [refenceDocumentType, setRefenceDocumentType] = useState("");
  const [referenceDocumentNumber, setReferenceDocumentNumber] = useState("");

  const [referenceDocumentDate, setReferenceDocumentDate] = useState("");
  const [datarows, setDatarows] = useState([]);
  const [naration, setNartation] = useState("");
  const [jounalNumberDialogOpen, setJounalNumberDialogOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  const [narationTouched, setNarationTouched] = useState(false);
  const [narationError, setNarationError] = useState(false);
  const [voucherDateError, setVoucherDateError] = useState(false);
  const [voucherDate, setVoucherDate] = useState("");
  const [voucherStatus, setVoucherStatus] = useState("");
  const [errorApplicationList, setErrorApplicationList] = useState([]);
  const [applicationList, setApplicationList] = useState([]);
  const [glDiscriptionList, setGlDiscriptionList] = useState({});
  const [glAccountErrorList, setGlAccountErrorList] = useState([]);
  const [creditEmptyErrorList, setCreditEmptyErrorList] = useState([]);
  const [debitAmountNotValid, setDebitAmountNotValid] = useState(false);
  const [glAccountNotPresent, setGlAccountNotPresent] = useState(false);
  const [accountNoIsnotReceipted, setAccountNoIsnotReceipted] = useState(false);
  const [notTallyErrorList, setNotTallyErrorList] = useState(false);
  const [glAccountDuplicateList, setGlAccountDuplicateList] = useState([]);
  const [gridVisible, setGridVisible] = useState(false);
  const [voucherValidDateError, setVoucherValidDateError] = useState(false);
  const [voucherNumberIsNotGenerated, setVoucherNumberIsNotGenerated] =
    useState(false);
  const [discardedBranchName, setDiscardedBranchName] = useState("");
  const [discardDialogOpen, setDiscardDialogOpen] = useState("");
  const [discardVoucherDate, setDiscardVoucherDate] = useState("");
  const userName = useSelector((state) => state.branch.userName);
  const [narationLengthError, setNarationLengthError] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [validationSnackBar, setValidationSnackBar] = useState(false);
  const [validationSnackBarMessage, setValidationSnackBarMessage] =
    useState("");
  const [showValidDataSnackBar, setShowValidDataSnackBar] = useState(false);
  const [addRowSnackBarShow, setAddRowSnackBarShow] = useState(false);
  const [saveOkButtonDisable, setsaveOkButtonDisable] = useState(false);
  const [validationList, setValidationList] = useState(new Set());
  const [glAccountDisplay, setGlAccountDisplay] = useState(false);
  const [creditColumnEnable, setCreditColumnEnable] = useState(null);
  const [debitColumnEnable, setDebitColumnEnable] = useState(null);
  //State for New Development
  const [branchWithCode, setBranchWithCode] = useState([]);
  const [gllList, setGllList] = useState({});
  const [glAccountWithDesc, setGlAccountWithDesc] = useState([]);
  const [gLAccountArray, setGLAccountArray] = useState([]);

  //Dialog State
  const [informationDialog, setInformationDialog] = useState(false);
  const [informationDialogMessage, setInformationDialogMessage] = useState("");
  //---------------------------------
  //shortcut keys
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const addRowRef = useRef(null);
  const deleteRowRef = useRef(null);
  const userNames = useSelector((state) => state.branch.userName);
  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, [jounalNumberDialogOpen]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "journalCreate",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      if (jounalNumberDialogOpen) {
        JounalNumberDialogOkClickHandler();
      }
    }
    let date = new Date();
    let refList = {
      searchButtonRef: searchButtonRef,
      clearRef: clearRef.current !== null ? clearRef : null,
      saveRef: saveRef,
      addRowRef: addRowRef,
      deleteRowRef: deleteRowRef.current !== null ? deleteRowRef : null,
    };
    if (event.ctrlKey) {
      let charCode = String.fromCharCode(event.which).toLowerCase();
      if (charCode === "r") {
        if (deleteRowRef.current) {
          deleteRowRef.current.click();
        }
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setVoucherDate(date);
      } else if (charCode === "i") {
        date = new Date();
        setVoucherDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setVoucherDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "journalCreate",
          })
        );
      }
    }
  };
  useEffect(() => {
    const branchWithCode = GetBranchDetailsWithCode();
    getGlAccountBasedOnBranchCode(branchWithCode);
    setBranchWithCode(branchWithCode);
    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    const branchNames = GetBranchDetailsWithCode();
    setBranchNames(branchNames);
    const branchList = [];
    branchNames.forEach((value) => {
      branchList.push(value.label);
    });
    setBranchNamesList(branchList);
    const activeBranchCode = branchWithCode.find((branchVal) => {
      return branchVal.label === branchName?.label;
    });
    let newRow = {
      id: 0,
      fileBranch: branchName?.label,
      appNum: "",
      glAccount: "",
      description: "",
      debit: "",
      credit: "",
      fileBranchCode: activeBranchCode ? activeBranchCode.code : "",
    };
    setGlAccountDisplay(false);

    let newList = [];
    newList.push(newRow);
    setDatarows(newList);
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
  }, []);

  const loadApplicationNumBasedOnBranchName = async (event) => {
    const dataMap = {};
    const selectedBranch = event.row.fileBranch;
    if (selectedBranch) {
      dataMap["branchName"] = selectedBranch;
      dataMap["branchCode"] = event.row.fileBranchCode;
      dataMap["screenMode"] = "CREATE";
      try {
        const response = await axios.post("/jv/getAppNum", dataMap);
        if (response.data) {
          setApplicationList(response.data);
        }
      } catch {
        console.log("Network Error");
      }
    } else {
      setApplicationList([]);
    }
  };
  const getGlAccountBasedOnBranchCode = async (branchWithCode) => {
    const codes = branchWithCode.map((branches) => branches.code);
    const response = await axios.post("/filereceipt/getGLAccountDataByBranch", {
      shflApisModel: {
        apiCode: "FILE_GL_ACC_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      },
      branchCodes: codes,
    });
    if (response.status === 200) {
      setGllList(response.data);
    }
  };
  const discardChange = () => {
    setDatarows([
      {
        id: 0,
        fileBranch: branchName.label,
        appNum: "",
        glAccount: "",
        description: "",
        debit: "",
        credit: "",
      },
    ]);
    setGlAccountDisplay(false);

    setUpdateDisable(true);
    setDiscardDialogOpen(false);
    setGridVisible(false);
    if (discardVoucherDate) {
      setVoucherDate(discardVoucherDate);
      return;
    }

    if (discardedBranchName?.label) {
      setBranchName(discardedBranchName.label);
      setVoucherDate(null);
    } else {
      setVoucherDate(null);
      setBranchName("");
    }
  };
  const saveDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setSaveDialogOpen(false);
        setsaveOkButtonDisable(false);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setSaveDialogOpen(false);
        setsaveOkButtonDisable(false);
      } else {
        setSaveDialogOpen(true);
      }
    }
  };
  const JounalNumberDialogOkClickHandler = () => {
    setSaveDialogOpen(false);
    setJounalNumberDialogOpen(false);
    window.location.reload();
  };
  const errorDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setErrorApplicationList([]);
        setGlAccountErrorList([]);
        setCreditEmptyErrorList([]);
        setEmptyRowList([]);
        setGlAccountNotPresent(false);
        setErrorDialogOpen(false);
        setGlAccountDuplicateList([]);
        setDebitAmountNotValid(false);
        setVoucherNumberIsNotGenerated(false);
        setNotTallyErrorList([]);
      }
    }
  };
  const closeDialogAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setDiscardDialogOpen(false);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setDiscardDialogOpen(false);
      } else {
        setDiscardDialogOpen(true);
      }
    }
  };

  //validation disbursement status
  const validateDisbursementStatus = async() =>{

    const applNumbers = await Promise.all(
      datarows.map(async(row)=>{
        return row.appNum
      })
    )
    const applicationNumbers = [...new Set(applNumbers)]
    const params = {
      "applicationNumber":applicationNumbers
      }
    try {
      setLoading(true)
      setLoadingMsg("Validating Disbursement Status...")
      let data;
      const response = await axios.post(
        "disbursement/validateDisbursementStatus",
        params
      );
      if (response.data) {
        data = response.data
      }
      setLoading(false)
      return data;
    } catch(error) {
      setLoading(false)
      setValidationSnackBarMessage("Network error");
      setValidationSnackBar(true);
      throw new Error("Network error")
    }
  }

  const onSaveButtonClickHandler = async () => {

      setSaveDialogOpen(false);
      const dataMap = {};
      dataMap["mode"] = "insert";
      dataMap["user"] = userName;
      dataMap["branchName"] = branchName.code;
      dataMap["branchCode"] = branchName.label;
      dataMap["gridData"] = datarows;
      dataMap["voucherId"] = voucherNumber;
      dataMap["voucherDate"] = new Date(voucherDate).toLocaleDateString("fr-FR");
      dataMap["voucherStatus"] = voucherStatus;
      dataMap["referenceDocumentType"] = refenceDocumentType;
      dataMap["referenceDocumenNumber"] = referenceDocumentNumber;
      dataMap["referenceDocumentDate"] = referenceDocumentDate;
      dataMap["naration"] = naration;
      dataMap["glDescMap"] = glDiscriptionList;
      dataMap["branchCodeList"] = branchNames;
      dataMap["needValidaionFlag"] = validationList.size !== 0;
      try {
        setLoading(true)
        setLoadingMsg("Saving Journal Voucher Details Please wait...")
        const response = await axios.post("/jv/saveJv", dataMap);
        if (response.data.saved) {
          setErrorDialogOpen(false);
          setNarationTouched(false)
          setSavedVoucherNumber(response.data.voucherId);
          setJounalNumberDialogOpen(true);
          setLoading(false)
        } else {
          setGlAccountDuplicateList(
            response.data.notAvailGl ? response.data.notAvailGl : []
          );
          setAccountNoIsnotReceipted(
            response.data.applicationNotAvail
              ? response.data.applicationNotAvail
              : []
          );
          if (response.data.applicationNotAvail && response.data.notAvailGl) {
            if (
              response.data.applicationNotAvail.length === 0 &&
              response.data.notAvailGl.length === 0
            ) {
              setNotTallyErrorList(
                response.data.notTallyList ? response.data.notTallyList : []
              );
            }
          }
          setVoucherNumberIsNotGenerated(
            !Boolean(response.data.voucherSeqGenerated)
          );
          setLoading(false)
          setSaveDialogOpen(false);
          setErrorDialogOpen(true);
        }
        setsaveOkButtonDisable(false);
      } catch {
        setLoading(false)
        console.log("Network Error");
      }

  };
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerAlign: "center",
      align: "left",
      flex: 1,
      editable: false,
      hide: true,
    },
    {
      field: "fileBranch",
      headerName: "File Branch",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: true,
      type: "singleSelect",
      valueOptions: branchNamesList,
    },
    {
      field: "appNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: true,
      type: "singleSelect",
      valueOptions: applicationList,
    },
    {
      field: "glAccount",
      headerName: "GL Account",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: glAccountDisplay,
      type: "singleSelect",
      valueOptions: gLAccountArray,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "GL Description",
      headerAlign: "center",
      align: "left",
      flex: 315,
      editable: false,
      disableColumnMenu: true,
    },
    {
      field: "debit",
      headerName: "Debit",
      headerAlign: "center",
      align: "right",
      flex: 165,
      type: "number",
      editable: debitColumnEnable,
      valueGetter: (value) => {
        if (value.value > 0 && value.value < 100000000) {
          return Number(value.value).toFixed(0);
        } else {
          return "";
        }
      },
    },
    {
      field: "credit",
      headerName: "Credit",
      headerAlign: "center",
      align: "right",
      flex: 165,
      type: "number",
      editable: creditColumnEnable,
      valueGetter: (value) => {
        if (value.value > 0 && value.value < 100000000) {
          return Number(value.value).toFixed(0);
        } else {
          return "";
        }
      },
    },

    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      editable: false,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Tooltip title="Ctrl+R" placement="right-start">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
              ref={deleteRowRef}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  //Button updation
  const [btnName, setBtnName] = useState("SAVE");
  //Button state to show or Hide

  const [branchName, setBranchName] = useState(null);
  const [branchNameNotValid, setBranchNameNotValid] = useState(false);
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [gridIsEmpty, setGridIsEmpty] = useState(false);
  const [emptyRowList, setEmptyRowList] = useState([]);
  const [modifiedMap, setModifiedMap] = useState({});
  const [updateDisable, setUpdateDisable] = useState(true);
  const handleSearch = (event) => {
    event.preventDefault();
    if (
      !branchName ||
      !voucherDate ||
      voucherDateError ||
      voucherValidDateError
    ) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
        setGridVisible(false);
      }
      if (!voucherDate || voucherDateError || voucherValidDateError) {
        voucherDate ? setVoucherDateError(false) : setVoucherDateError(true);
        setGridVisible(false);
      }
    } else {
      const branchWithCode = GetBranchDetailsWithCode();
      const activeBranchCode = branchWithCode.find((branchVal) => {
        return branchVal.label === branchName?.label;
      });
      let newRow = {
        id: 0,
        fileBranch: branchName.label,
        appNum: "",
        glAccount: "",
        description: "",
        debit: "",
        credit: "",
        fileBranchCode: activeBranchCode.code,
      };
      let newList = [];
      setGlAccountDisplay(false);

      newList.push(newRow);
      setGridVisible(true);
      setDatarows(newList);
      setModifiedMap(getModifiedData(datarows));
    }
  };
  const checkUpdatedValueWithModifiedData = (key, value) => {
    if (
      modifiedMap[
        key["fileBranch"] +
          key["appNum"] +
          key["glAccount"] +
          key["debit"] +
          key["credit"]
      ] !== value
    ) {
      setUpdateDisable(false);
    }
  };
  const getModifiedData = (gridData) => {
    let modifiedMap = {};
    gridData.forEach(function (key) {
      modifiedMap[key["id"]] =
        key["fileBranch"] +
        key["appNum"] +
        key["glAccount"] +
        key["debit"] +
        key["credit"];
    });
    return modifiedMap;
  };
  const validateNaration = (value) => {
    if(value){
      setNarationError(false)
      if (value.length > 2000) {
        setNarationLengthError(true);
      } else {
        setNarationLengthError(false);
      }
    }else{
      setNarationError(true)
    }
  };
  const clearButtonClickHandler = () => {
    setBranchName("");
    setVoucherDate(null);
    setVoucherStatus("");
    setDatarows([]);

    setVoucherDateError(false);
    setVoucherValidDateError(false);
    setBranchNameNotValid(false);
    setNartation("");
    setNarationError(false);
    setUpdateDisable(true);
    setGridVisible(false);
  };
  const onChangeForBranchEvent = (event, newValue) => {
    setBranchName(newValue);
    if (newValue?.label) {
      dispatch(BranchAction.updateInitialLoad(false));
      dispatch(BranchAction.updateHeaderBranchDetails(newValue.label));
    }
    if (newValue === null || newValue === "") {
      return;
    } else {
      setBranchNameNotValid(false);
    }
  };
  const glAccountOnChangeHandler = (params) => {
    const dataIndex = datarows.findIndex((data) => {
      return data.id === params.id;
    });
    let data = datarows[dataIndex];
    const activeRowValue = datarows.find((data) => {
      return data.id === params.id;
    });
    const filterValue = datarows.map((data) => {
      return activeRowValue.appNum === data.appNum ? data : "";
    });
    let clearFlag;
    if (
      `${activeRowValue.glAccount} - ${activeRowValue.description}` ===
      params.value
    ) {
      clearFlag = false;
    } else {
      filterValue.forEach((data) => {
        const retrivalData = glAccountWithDesc.find((data) => {
          return (
            `${data["account_head"]} - ${data["account_desc"]}` === params.value
          );
        });
        if (data.glAccount === retrivalData.account_head) {
          clearFlag = true;
        }
      });
    }
    let datas;
    if (clearFlag) {
      setInformationDialog(true);
      setInformationDialogMessage(
        `This GL Account ${params.value} Is Already Used.`
      );

      datas = {
        ...data,
        glAccount: "",
        description: "",
        debit: 0,
        credit: 0,
      };
    } else {
      const retrivalData = glAccountWithDesc.find((data) => {
        return (
          `${data["account_head"]} - ${data["account_desc"]}` === params.value
        );
      });
      datas = {
        ...data,
        glAccount: retrivalData.account_head,
        description: retrivalData.account_desc,
        debit: 0,
        credit: 0,
      };
      // }
    }
    let newItem = [...datarows];
    newItem[dataIndex] = datas;
    setDatarows(newItem);
  };
  const getDebitAmountForGlAccount = async (fileBranch, appNum, glAccount) => {
    try {
      const selectedBranchCode = branchWithCode.find((branchVal) => {
        return branchVal.label === fileBranch;
      });
      const response = await axios.post("/jv/getGlAccDebitAmountFromReceipt", {
        branch: fileBranch,
        branchCode: selectedBranchCode.code,
        glAcc: glAccount,
        appNum: appNum,
        voucherNum: null,
      });
      return response;
    } catch (e) {}
  };
  const handleCellChangedEvent = async (event) => {
    if (event.field === "fileBranch") {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      if (event.value) {
        datarows[data]["glAccount"] = "";
        datarows[data]["description"] = "";
        datarows[data]["appNum"] = "";
        datarows[data]["fileBranch"] = event.value;
        const selectedBranchCode = branchWithCode.find((branchVal) => {
          return branchVal.label === event.value;
        });
        datarows[data]["fileBranchCode"] = selectedBranchCode.code;
        setDatarows([...datarows]);
      } else {
        datarows[data] = {};
        setDatarows([...datarows]);
      }
    } else if (event.field === "appNum") {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      datarows[data]["appNum"] = event.value;
      datarows[data]["glAccount"] = "";
      datarows[data]["description"] = "";
      datarows[data]["debit"] = "";
      datarows[data]["credit"] = "";
      setDatarows([...datarows]);
    } else if (event.field === "glAccount") {
      glAccountOnChangeHandler(event);
    } else if (
      (event.field === "debit" || event.field === "credit") &&
      Number(event.value) >= 0 &&
      Number(event.value) <= 99999999
    ) {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      if (event.field === "debit") {
        const { fileBranch, appNum, glAccount } = datarows[data];
        if (
          fileBranch !== null &&
          fileBranch !== "" &&
          fileBranch !== undefined &&
          appNum !== null &&
          appNum !== "" &&
          appNum !== undefined &&
          glAccount !== null &&
          glAccount !== "" &&
          glAccount !== undefined
        ) {
          const response = await getDebitAmountForGlAccount(
            fileBranch,
            appNum,
            glAccount
          );
          if (response.data.receiptFlag) {
            if (event.value <= response.data.amount) {
              datarows[data][event.field] = event.value;
              setDatarows([...datarows]);
            } else {
              datarows[data][event.field] = 0;
              setDatarows([...datarows]);
              setValidationSnackBarMessage(
                "Enter Debit Amount is greater that Receipt Amount"
              );
              setValidationSnackBar(true);
            }
          } else {
            setValidationSnackBarMessage(
              `Receipt is Not Created for this GL ${datarows[data]["glAccount"]} Account.`
            );
            setValidationSnackBar(true);
            datarows[data]["glAccount"] = "";
            datarows[data]["description"] = "";
            datarows[data]["debit"] = 0;
            setDatarows([...datarows]);
          }
        } else {
          setValidationSnackBarMessage(`Please Select Required Fields.`);
          setValidationSnackBar(true);
          datarows[data]["debit"] = 0;
          setDatarows([...datarows]);
        }
      } else {
        datarows[data][event.field] = event.value;
        setDatarows([...datarows]);
      }
    } else {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      datarows[data][event.field] = 0;
      setDatarows([...datarows]);
      setShowSnackBar(true);
    }
    setUpdateDisable(
      JSON.stringify(modifiedMap) === JSON.stringify(getModifiedData(datarows))
    );
    if (event.field === "appNum") {
      setGlAccountDisplay(true);
    }
  };
  const onRowClickHandler = (params) => {
    getGlAccountsBasedOnBranch(params.fileBranch);
  };
  const getGlAccountsBasedOnBranch = (branch) => {
    if (branch === "" || branch === null) {
      setGlAccountWithDesc([]);
      setGLAccountArray([]);
    } else {
      const selectedBranch = branchWithCode.find((branchVal) => {
        return branchVal.label === branch;
      });
      const GlDetails = gllList[selectedBranch.code];

      const GLValAndDesArray = GlDetails.ledger_details.map((data) => data);
      setGlAccountWithDesc(GLValAndDesArray);

      const GlAccount = GlDetails.ledger_details.map((data) => {
        return `${data["account_head"]} - ${data["account_desc"]}`;
      });
      setGLAccountArray(GlAccount);
    }
  };
  const valiateTosave = async() => {
    if (!branchName || !voucherDate) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherDate) {
        voucherDate ? setVoucherDateError(false) : setVoucherDateError(true);
      }
      if (datarows.length > 0) {
        datarows.length > 0 ? setGridIsEmpty(false) : setGridIsEmpty(true);
      }
    } else {
      setGridIsEmpty(false);
      if (!checkGridDataVaidation()) {
        setErrorDialogOpen(true);
      }else if(naration===null || naration===""){
        setNarationError(true);
      } else if (naration.length > 2000) {
        setNarationLengthError(true);
        setErrorDialogOpen(true);
      } else if(!await validateDisbursementStatus()){
        setValidationSnackBarMessage("Unable to proceed due to disbursement is in Requested/Partial Approval State");
        setValidationSnackBar(true);
        setSaveDialogOpen(false);
        setsaveOkButtonDisable(false);
      } else {
        setNarationLengthError(false);
        setNarationError(false);
        setSaveDialogOpen(true);
      }
    }
  };
  const checkGridDataVaidation = () => {
    let allowSave = true;
    let errorList = [];
    let glAccountErrorList = [];
    let glMap = [];
    let creditEmptyErrorList = [];
    let emptyRowList = [];
    let debitCount = 0;
    let creditCount = 0;
    datarows.forEach(function (map, index) {
      creditCount = Number(map["credit"]) + creditCount;
      debitCount = Number(map["debit"]) + debitCount;
      if (
        !map["appNum"] ||
        !map["glAccount"] ||
        !map["fileBranch"] ||
        (!map["credit"] &&
          !map["debit"] &&
          (map["credit"] === 0 ||
            map["credit"] === "" ||
            map["credit"] === undefined) &&
          (map["debit"] === 0 ||
            map["debit"] === "" ||
            map["debit"] === undefined))
      ) {
        allowSave = false;
        creditEmptyErrorList.push(map["id"]);
      }
      if (
        glMap &&
        map["appNum"] + map["glAccount"] &&
        glMap.includes(map["appNum"] + map["glAccount"])
      ) {
        if (!glAccountErrorList.includes(map["glAccount"])) {
          glAccountErrorList.push(map["glAccount"]);
        }
        allowSave = false;
      } else {
        glMap.push(map["appNum"] + map["glAccount"]);
      }
      if (map["debit"] && map["credit"]) {
        allowSave = false;
        errorList.push(map["appNum"]);
      }
      if (
        !map["debit"] &&
        !map["credit"] &&
        !map["fileBranch"] &&
        !map["glAccount"] &&
        !map["appNum"]
      ) {
        emptyRowList.push(map["id"]);
        allowSave = false;
      }
    });
    if (validationList.size !== 0 && datarows.length !== validationList.size) {
      setGlAccountNotPresent(true);
      allowSave = false;
    }
    if (debitCount !== creditCount) {
      allowSave = false;
      errorList.push("");
    }

    setErrorApplicationList(errorList);
    setGlAccountErrorList(glAccountErrorList);
    setCreditEmptyErrorList(creditEmptyErrorList);
    setEmptyRowList(emptyRowList);
    return allowSave;
  };
  const updateGridValue = (newValue) => {
    let newList = [];
    datarows.forEach((map, index) => {
      if (map) {
        map["fileBranch"] = newValue?.label ? newValue.label : "";
        map["id"] = index;
        map["appNum"] = "";
        map["glAccount"] = "";
        map["debit"] = 0;
        map["credit"] = 0;
      }
      newList.push(map);
    });
    setDatarows(newList);
  };
  const addNewRow = () => {
    const branchWithCode = GetBranchDetailsWithCode();

    const activeBranchCode = branchWithCode.find((branchVal) => {
      return branchVal.label === branchName?.label;
    });
    let newRow = {
      id: datarows.length,
      fileBranch: branchName?.label,
      appNum: "",
      glAccount: "",
      description: "",
      debit: "",
      credit: "",
      fileBranchCode: activeBranchCode ? activeBranchCode.code : "",
    };
    if (datarows.length > 0) {
      setGlAccountDisplay(false);

      let rowMap = datarows[datarows.length - 1];
      if (
        (rowMap["credit"] || rowMap["debit"]) &&
        rowMap["fileBranch"] &&
        rowMap["glAccount"] &&
        rowMap["appNum"]
      ) {
        setDatarows((prevRows) => [...prevRows, newRow]);
      } else {
        setAddRowSnackBarShow(true);
      }
    } else {
      setGlAccountDisplay(false);

      let newList = [];
      newList.push(newRow);
      setDatarows([newRow]);
      setUpdateDisable(true);
    }
  };
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);

  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Journal Voucher Request Date Back Count"] &&
        new Date(
          paramValues["Journal Voucher Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Journal Voucher Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.journalCreateVoucherDate &&
        fieldAccessMap.journalCreateVoucherDateBackCount
          ? Number(
              paramValues["Journal Voucher Request Date Back Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Journal Voucher Request Date Future Count"] &&
        new Date(
          paramValues["Journal Voucher Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Journal Voucher Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.journalCreateVoucherDate &&
        fieldAccessMap.journalCreateVoucherDateFutureCount
          ? Number(
              paramValues["Journal Voucher Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }
  const deleteSelectedRow = (param) => {
    let deletedData = datarows.filter((row) => row.id !== param.id);
    setDatarows(deletedData);
    validationList.delete(param["glAccount"]);
    setValidationList(validationList);
    if (deletedData.length === 0) {
      setUpdateDisable(true);
    }
  };
  return (
    <>
    {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord-jv"
            title="Journal Voucher Create"
            initialOpen={true}
          >
            <Box id="accord-box-jv-create" component="form" validate="true">
              <Grid item container spacing={1}>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomAutoComplete
                    required={true}
                    label="Branch"
                    id="branch"
                    variant="standard"
                    value={branchName}
                    onChange={(event, newValue) => {
                      if (updateDisable) {
                        onChangeForBranchEvent(event, newValue);
                        updateGridValue(newValue);
                      } else {
                        setDiscardedBranchName(newValue);
                        setDiscardDialogOpen(true);
                      }
                    }}
                    type="text"
                    placeholder="Branch"
                    autoCompleteValues={branchNames}
                  />
                  {branchNameNotValid && (
                    <p className="error">Please Select Branch</p>
                  )}
                </Grid>

                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomDateField
                    required={true}
                    label="Voucher Date"
                    id="dueDate"
                    disablePast={false}
                    variant="standard"
                    value={voucherDate}
                    type="text"
                    minDate={new Date().setDate(
                      new Date().getDate() - minDateAddValue
                    )}
                    maxDate={new Date().setDate(
                      new Date().getDate() + maxDateAddValue
                    )}
                    placeholder="Voucher Date"
                    onChange={(event) => {
                      if (updateDisable) {
                        if (!event) {
                          setVoucherDate(null);
                        } else {
                          setVoucherDate(new Date(event));
                        }
                        setVoucherDateError(false);
                        setVoucherStatus("Requesting");
                      } else {
                        setDiscardDialogOpen(true);
                        setDiscardVoucherDate(new Date(event));
                      }
                      new Date(event).toDateString() !== "Invalid Date" &&
                      event !== null &&
                      new Date(event).toLocaleDateString().slice(-4) >=
                        "1970" &&
                      new Date(event).toLocaleDateString().slice(-4) <=
                        "2055" &&
                      new Date(event) >=
                        new Date(
                          dayjs(
                            new Date().setDate(
                              new Date().getDate() - minDateAddValue
                            )
                          ).format("MM/DD/YYYY")
                        ) &&
                      new Date(event) <=
                        new Date(
                          dayjs(
                            new Date().setDate(
                              new Date().getDate() + maxDateAddValue
                            )
                          ).format("MM/DD/YYYY")
                        )
                        ? setVoucherValidDateError(false)
                        : setVoucherValidDateError(true);
                    }}
                  />
                  {(voucherDateError || voucherValidDateError) && (
                    <p className="error">Please Enter Valid Date</p>
                  )}
                </Grid>

                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomTextField
                    required={false}
                    disabled={true}
                    label="Voucher Status"
                    id="refdate"
                    value={voucherStatus}
                    type="text"
                    placeholder=""
                    variant="standard"
                  />
                </Grid>
              </Grid>
              <Box
                sx={{
                  margin: "8px 4px 4px 4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Ctrl+F" placement="top">
                  <Button
                    sx={{
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                    variant="contained"
                    type="submit"
                    onClick={(event) => handleSearch(event)}
                    ref={searchButtonRef}
                  >
                    Go
                  </Button>
                </Tooltip>
                <Tooltip title="Ctrl+D" placement="top">
                  <Button
                    sx={{
                      marginLeft: "8px",
                      color: "white",
                      backgroundColor: "black",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                    onMouseOver={({ target }) => {
                      target.style.backgroundColor = "black";
                      target.style.color = "white";
                    }}
                    ref={clearRef}
                    variant="contained"
                    onClick={() => clearButtonClickHandler()}
                  >
                    Clear
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </AccordianContainer>
          {gridVisible && (
            <AccordianContainer
              id="accord-jv"
              title="Journal Voucher Information"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                <div
                  style={{
                    direction: "rtl",
                    marginBottom: "4px",
                  }}
                >
                  <Tooltip title="Ctrl+A">
                    <CustomButton
                      variant="contained"
                      onClick={() => addNewRow()}
                      ref={addRowRef}
                    >
                      +
                    </CustomButton>
                  </Tooltip>
                </div>
                <CustomDataGrid
                  noDataMessage="No Data."
                  noDataOnFilterMessage="No Data on Applied Filter."
                  rows={datarows}
                  columns={columns}
                  rowHeight={40}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  isCellEditable={() => true}
                  onSortModelChange={() => {}}
                  gridHeight={
                    datarows.length < 5 && datarows.length !== 0
                      ? datarows.length * 40 + 130
                      : 305
                  }
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" ||
                      param.key === "E" ||
                      param.key === "." ||
                      param.key.includes("-")) &&
                      param.preventDefault();
                    checkUpdatedValueWithModifiedData(
                      event,
                      param.target.value
                    );
                  }}
                  onCellEditCommit={(event) => handleCellChangedEvent(event)}
                  onRowClick={(params) => {
                    onRowClickHandler(params.row);
                    if (
                      (params.row.debit === "" ||
                        params.row.debit === null ||
                        params.row.debit === 0) &&
                      (params.row.credit === "" ||
                        params.row.credit === null ||
                        params.row.credit === 0)
                    ) {
                      setDebitColumnEnable(true);
                      setCreditColumnEnable(true);
                    } else if (
                      (params.row.debit === "" ||
                        params.row.debit === null ||
                        params.row.debit === 0) &&
                      (params.row.credit !== "" ||
                        params.row.credit !== null ||
                        params.row.credit !== 0)
                    ) {
                      setDebitColumnEnable(false);
                      setCreditColumnEnable(true);
                    } else if (
                      (params.row.debit !== "" ||
                        params.row.debit !== null ||
                        params.row.debit !== 0) &&
                      (params.row.credit === "" ||
                        params.row.credit === null ||
                        params.row.credit === 0)
                    ) {
                      setDebitColumnEnable(true);
                      setCreditColumnEnable(false);
                    }
                  }}
                  onCellDoubleClick={(event) => {
                    if (event.field === "appNum") {
                      if (
                        event.row.fileBranch !== "" &&
                        event.row.fileBranch !== null
                      ) {
                        loadApplicationNumBasedOnBranchName(event);
                      } else {
                        setApplicationList([]);
                      }
                    } else if (event.field === "glAccount") {
                      if (
                        event.row.appNum !== "" &&
                        event.row.appNum !== null
                      ) {
                        setGlAccountDisplay(true);
                      } else {
                        setGlAccountDisplay(false);
                      }
                    }
                  }}
                />
                {gridIsEmpty && (
                  <p className="error">Voucher Table Value is Empty</p>
                )}
                <Grid container rowSpacing={0} columnSpacing={1}>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomTextField
                      type="naration"
                      label="Narration"
                      variant="standard"
                      disabled={false}
                      required={true}
                      value={naration}
                      onChange={(event) => {
                        setNarationTouched(true)
                        setNartation(event.target.value)}}
                      onBlur={(event) => validateNaration(event.target.value)}
                    ></CustomTextField>
                    {narationError && (
                      <p className="error">Please Enter Naration</p>
                    )}
                    {narationLengthError && (
                      <p className="error">
                        Value is too long. Input less than 2000 characters.
                      </p>
                    )}
                  </Grid>
                </Grid>
              </>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Ctrl+S" placement="top">
                  <Button
                    id="stlap-jv-button"
                    disabled={updateDisable}
                    variant="contained"
                    onClick={() => {
                      setTimeout(() => {
                        valiateTosave();
                      }, 1500);
                    }}
                    ref={saveRef}
                  >
                    {btnName}
                  </Button>
                </Tooltip>
              </Box>
            </AccordianContainer>
          )}
        </Grid>
        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Save Journal Voucher Details ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          disabled={saveOkButtonDisable}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            setsaveOkButtonDisable(true);
            onSaveButtonClickHandler();
            setUpdateDisable(false);
          }}
          onDialogClose={saveDialogCloseAction}
        />
        <CustomConfirmationDialog
          dialogOpen={jounalNumberDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                Journal Voucher Saved Successfully
              </Typography>
              <Typography sx={{ fontSize: "1rem" }}>
                Voucher Number {savedVoucherNumber}
              </Typography>
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={JounalNumberDialogOkClickHandler}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              {errorApplicationList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Entered Application Numbers Credit/Debit Value is mismatched
                </Typography>
              )}

              {glAccountErrorList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  The Following Application Numbers Gl Account Numbers are
                  duplicate, Kindly Check Once Again
                </Typography>
              )}
              {glAccountErrorList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  {glAccountErrorList.join(", ")}
                </Typography>
              )}
              {creditEmptyErrorList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Please Fill all the values.
                </Typography>
              )}
              {naration.length > 2000 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Narration length exceeded.
                </Typography>
              )}

              {emptyRowList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some Empty row in the table.
                </Typography>
              )}
              {glAccountNotPresent && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Gl Account is not present in File Receipt.
                </Typography>
              )}
              {accountNoIsnotReceipted.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  The Following Application Numbers is not present in File
                  Receipt.
                </Typography>
              )}
              {accountNoIsnotReceipted.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  {accountNoIsnotReceipted.join(", ")}
                </Typography>
              )}
              {glAccountDuplicateList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  The Following Application Numbers Gl Account is not present in
                  File Receipt.
                </Typography>
              )}
              {glAccountDuplicateList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  {glAccountDuplicateList.join(", ")}
                </Typography>
              )}
              {debitAmountNotValid > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Debit/Credit amount is greater than file Receipt Gl Amount.
                </Typography>
              )}
              {voucherNumberIsNotGenerated && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Not able to save details, Voucher Charset is not generated
                  yet.
                </Typography>
              )}
              {notTallyErrorList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Your Entered Amount is greater than the receipt amount for the
                  following applications.
                </Typography>
              )}
              {notTallyErrorList.length > 0 && (
                <Typography sx={{ fontSize: "1rem" }}>
                  {notTallyErrorList.join(", ")}
                </Typography>
              )}
            </>
          }
          hideCancelButton={true}
          onDialogClose={errorDialogCloseAction}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => {
            setErrorApplicationList([]);
            setGlAccountErrorList([]);
            setCreditEmptyErrorList([]);
            setEmptyRowList([]);
            setGlAccountNotPresent(false);
            setErrorDialogOpen(false);
            setGlAccountDuplicateList([]);
            setDebitAmountNotValid(false);
            setVoucherNumberIsNotGenerated(false);
            setNotTallyErrorList([]);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={discardDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are you sure want to discard changes ?"}
          hideCancelButton={false}
          okButtonName={"Yes"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            discardChange();
          }}
          onDialogClose={closeDialogAction}
        />
        <CustomSnackBar
          showSnackbar={showSnackBar}
          autoHideDuration={5000}
          onClose={() => {
            setShowSnackBar(false);
          }}
          message={"Amount should be greater than 0 and less than 9,99,99,999"}
          severity="warning"
          color={"red"}
        />
        <Snackbar
          open={validationSnackBar}
          autoHideDuration={3000}
          onClose={() => {
            setValidationSnackBar(false);
          }}
        >
          <Alert
            onClose={() => {
              setValidationSnackBar(false);
            }}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {validationSnackBarMessage}
          </Alert>
        </Snackbar>
        <Dialog
          open={informationDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Information</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {informationDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  setInformationDialog(false);
                }}
              >
                Ok
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <CustomSnackBar
          showSnackbar={addRowSnackBarShow}
          autoHideDuration={5000}
          onClose={() => {
            setAddRowSnackBarShow(false);
          }}
          message={"Please Enter all fileld value"}
          severity="warning"
          color={"red"}
        />
        <CustomSnackBar
          showSnackbar={showValidDataSnackBar}
          autoHideDuration={5000}
          onClose={() => {
            setShowValidDataSnackBar(false);
          }}
          message={"Please Enter Valid Amount"}
          severity="warning"
          color={"red"}
        />
      </div>
      <StlapFooter />
    </>
  );
};
export default JournalVoucher;
